<template>
  <b-modal
    ref="modal"
    centered
    v-model="selfValue"
    :hide-footer="true"
    @hide="close()"
    header-bg-variant="danger"
    header-text-variant="white"
    body-bg-variant="white"
    body-text-variant="primary"
  >
    <template v-if="error">
      <template slot="modal-header">
        <a href="#" class="d-block text-white text-right modal-close" @click.prevent="close()">
          <small>
            Fermer
            <span aria-hidden="true" class="times">&times;</span>
          </small>
        </a>
        <h2 class="pt-4 pb-3 px-3">{{error.title}}</h2>
      </template>

      <div class="px-3">
        <p>Une erreur inattendue est survenue :</p>
        <p>{{error.message}}</p>
        <p>Si cette erreur persiste, veuillez contacter un administrateur</p>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ErrorModal",
  props: {
    value: Boolean,
    error: Object
  },
  data() {
    return {
      selfValue: this.value
    };
  },
  watch: {
    value() {
      this.selfValue = this.value;
    }
  },
  methods: {
    close() {
      this.selfValue = false;
      this.$emit("input", false);
    }
  }
};
</script>